export const sitesChannelHc = {
  paginasWeb: {
    pageTitle: "Página web",
    introCreated: "Tu web ya está creada. Entra a editarla cuando quieras.",
    introEmpty:
      "Crea la web de tu alojamiento, con tu calendario dentro. Se edita arrastrando, sin escribir código.",
    emptyTitle: "Todavía no tienes web",
    emptyBody:
      "Eliges una plantilla del sector, cambias las fotos y los textos, y ya tienes una web publicable. El buscador de fechas queda conectado a tu calendario.",
    creating: "Creando…",
    createCta: "Crear mi web",
    createAnother: "Crear otra web",
    collapse: "Plegar",
    expand: "Ver detalles",
    limitReached: "Tu plan llega a {n} web(s).",
    lockedTitle: "Tu página web viene con el plan Suite",
    lockedBody:
      "Para crear y gestionar la web de tu alojamiento con WACheckin necesitas tener activo el plan Suite.",
    lockedCta: "Ver el plan Suite",
    nameLabel: "Nombre de tu web",
    viewWeb: "Ver la web",
    opening: "Abriendo…",
    editCta: "Editar mi página",
    noPublicAddress: "Todavía no tiene dirección pública",
    published: "Publicada",
    unpublished: "Sin publicar",
    visibleToPublic: "Visible para el público",
    addressTitle: "Dirección de tu web",
    addressSubtitle: "Elige en qué dirección quieres que la vean tus huéspedes.",
    modeWacheckin: "Usa una dirección de WACheckin",
    modeWacheckinHint: "Gratis y lista al momento",
    modeOwn: "Usa tu propio dominio",
    modeOwnHint: "Si ya tienes uno contratado",
    subdomainLabel: "La palabra que va delante",
    subdomainPlaceholder: "nombre-de-tu-alojamiento",
    saving: "Guardando…",
    save: "Guardar",
    subdomainPreview: "Tu web quedará en",
    subdomainFree:
      "Escríbelo como quieras: lo convertimos en una dirección válida.",
    otherDomainNote:
      "Tienes además {dominio} conectado. Esta dirección seguirá funcionando y llevará a la misma web.",
    noDomainYet: "Aún no has dicho qué dominio quieres",
    continueConnection: "Continuar la conexión",
    connectDomain: "Conectar mi dominio",
    searchTitle: "Qué alojamientos puede consultar el buscador",
    searchSubtitle:
      "Los que marques aquí son los que verán tus huéspedes al buscar fechas.",
    missingPhotosLabel: "Sin fotos todavía:",
    missingPhotosHelp:
      "Súbeselas en Reservas directas → Imágenes y aparecerán aquí. No hace falta que estén a la venta.",
    previewError: "No se ha podido cargar la previa.",
    previewRetry: "Volver a intentarlo",
    deleteExplain: "Se borra la web y todo lo que hay dentro. No se puede deshacer.",
    deleteTitle: "¿Eliminar «{nombre}»?",
    deleteBody: "Esto no se puede deshacer. Si solo quieres que deje de verse, apaga «Visible para el público» y la web se queda guardada.",
    deleteItemPages: "Sus {n} páginas, con sus textos y su diseño",
    deleteItemAddress: "La dirección en la que se ve ahora",
    deleteItemMessages: "Los mensajes que te llegaron por sus formularios",
    deleteCancel: "Cancelar",
    deleteConfirm: "Sí, eliminar",
    deleting: "Eliminando…",
    previewTitle: "Tu web ahora mismo",
    previewDesktop: "Ordenador",
    previewMobile: "Móvil",
    previewLoading: "Cargando tu web…",
    previewNote: "Así se ve con los últimos cambios guardados. Lo que ven tus huéspedes es lo último que publicaste.",
    footerNote:
      "Por ahora cada cuenta tiene una web. Escríbenos si necesitas más.",
    deleteWeb: "Eliminar esta web",
    mensajes: {
      title: "Mensajes de tu web",
      subtitle: "Lo que te escriben en los formularios de tu web. También te llega cada uno por correo.",
      inbox: "Bandeja",
      archived: "Archivados",
      unread: "{n} sin leer",
      empty: "Todavía no te ha escrito nadie. Cuando alguien rellene un formulario de tu web lo verás aquí, y te llegará por correo.",
      emptyArchived: "No tienes mensajes archivados.",
      loadError: "No se pudieron cargar los mensajes.",
      retry: "Reintentar",
      reply: "Responder por correo",
      whatsapp: "WhatsApp",
      call: "Llamar",
      markRead: "Marcar como leído",
      markUnread: "Marcar como no leído",
      archive: "Archivar",
      unarchive: "Devolver a la bandeja",
      delete: "Borrar",
      confirmDelete: "¿Borrar este mensaje? No se puede deshacer.",
      confirmYes: "Sí, borrar",
      confirmNo: "No",
      form: "Formulario",
      from: "Desde",
      more: "Ver más",
      anonymous: "Sin nombre",
      replySubject: "Tu mensaje en {sitio}",
      notSent: "El aviso por correo no ha salido todavía.",
      errorAction: "No se pudo guardar el cambio. Inténtalo otra vez.",
    },
    loadingAccommodations: "Cargando tus alojamientos…",
    noPhotosYet:
      "Ninguno de tus alojamientos tiene fotos todavía. Súbeselas en Reservas directas → Imágenes y podrás enseñarlos aquí.",
    noAccommodations: "Aún no tienes alojamientos creados.",
    loadError: "No se pudieron cargar tus páginas.",
    defaultSiteName: "Mi alojamiento",
    createError: "No se pudo crear la página.",
    saveError: "No se pudo guardar.",
    subdomainTooLong: "Se ha quedado demasiado largo.",
    subdomainReserved: "Esa palabra está reservada. Prueba con otra.",
    addressSaved: "Dirección guardada.",
    subdomainChecking: "Comprobando si está libre…",
    subdomainAvailable: "Está libre. Tu web quedará en",
    subdomainChangeWarning: "Al guardarla, la dirección de ahora dejará de abrir.",
    subdomainTaken: "Esa dirección ya la usa otra web.",
    subdomainTryThis: "Esta está libre:",
    subdomainUse: "Usar esta",
    subdomainGeneric: "No dice nada de tu alojamiento. Te proponemos:",
    subdomainProposal: "Te proponemos una con el nombre de tu alojamiento:",
    domainHelpEmpty:
      "Te guiamos paso a paso: escribes el dominio, copias dos líneas en el panel donde lo compraste y lo comprobamos nosotros.",
    domainHelpPending:
      "Faltan los apuntes en el panel de tu dominio, o todavía no han llegado a todas partes. Entra y lo comprobamos.",
    popupBlocked: "Permite las ventanas emergentes para abrir el editor.",
    editorError: "No se pudo abrir el editor.",
    confirmDelete: `¿Eliminar "{nombre}"? La web dejará de verse.`,
    deleteError: "No se pudo eliminar.",
  },

  selectOta: {
    lockBadge: "Función de suscripción",
    lockTitle: "Conecta tus OTAs con un plan activo",
    lockText:
      "Para sincronizar <b>Booking, Airbnb, Vrbo, Expedia</b> y más canales con WA&nbsp;Checkin necesitas estar suscrito a un plan. Con tu suscripción, Janet sincroniza precios, disponibilidad y reservas automáticamente — sin overbooking y sin tareas manuales.",
    morePreviewTitle: "y más de 100 OTAs",
    otasAvailable: "OTAs disponibles",
    lockCta: "Ver planes y suscribirme",
    lockFoot:
      "Sincronización automática · Anti-overbooking · Soporte de conexión incluido",
    connectOtaTitle: "Conectar OTA",
    googleFaltan: "A tu ficha le falta 1 cosa para Google | A tu ficha le faltan {count} cosas para Google",
    googlePreparar: "Prepararla",
    beta: "Beta",
    pctChipTitle: "Porcentaje de tarifa derivada para esta OTA",
    comingSoon: "Próximamente",
    manage: "Administrar",
    connectNow: "Conectar ahora",
    pctModalTitle: "Porcentaje de tarifa",
    pctModalHint:
      "¿Qué porcentaje de más (o de menos) vas a cobrar a tus huéspedes si reservan por <b>{ota}</b>? Usa <b>+</b> para cobrar más o <b>−</b> para cobrar menos (ej.: <b>15.5</b> o <b>−10</b>).",
    thisOta: "esta OTA",
    cancel: "Cancelar",
    saving: "Guardando…",
    save: "Guardar",
    exploreMore: "Explorar más de 100 OTA disponibles",
    activeConnections: "Conexiones Activas",
    searchPlaceholder: "Buscar...",
    loadingConnections: "Cargando conexiones...",
    thChannel: "CANAL",
    thConnectionId: "ID CONEXIÓN",
    thLastSync: "ÚLTIMA SINCRONIZACIÓN",
    thActions: "ACCIONES",
    copied: "¡Copiado!",
    copyId: "Copiar ID",
    contactTitle: "Conéctate con {name}",
    contactDescription:
      "Conecta fácilmente tu cuenta de {name} a nuestra plataforma para agilizar tu experiencia. Sigue los pasos a continuación para completar el proceso.",
    step1Title: "Crea una cuenta {name}",
    step1Description:
      "Si aún no tienes una cuenta de {name}, primero tendrás que crear una.",
    createAccountLink: "Crear cuenta →",
    step1Hint: "¿Ya tienes una cuenta? Pasa al paso 2.",
    step2Title: "Contactar al equipo de soporte",
    step2Description:
      "Una vez que tengas tu cuenta de {name} lista, nuestro equipo te ayudará a conectarla.",
    contactSupportLink: "Contactar al equipo de soporte →",
    connectDirectNoSupport: "Conectar directamente (sin soporte) →",
    step2Hint: "Recomendado solo si sabes lo que vas a configurar en Channex.",
    connectDirectly: "Conectar directamente",
    iframeTitle: "Conectar con {channel}",
    iframeSubtitle: "Conexión segura gestionada por el channel manager",
    close: "Cerrar",
    iframeLoading: "Abriendo la conexión segura…",
    actionRequired: "Acción requerida",
    viewPlans: "Ver planes",
    descBooking: "Alcanza viajeros de negocios y ocio en todo el mundo",
    descAirbnb: "Conecta tu propiedad con millones de viajeros en Airbnb",
    descVrbo: "Especializado en alquileres vacacionales para familias",
    descExpedia: "Red global de viajes con millones de usuarios activos",
    descBnb: "Portal italiano de B&B y alojamientos con encanto",
    descGvr: "Aparece gratis en los resultados de Google Maps y búsquedas",
    descAgoda: "Llega a viajeros de Asia y del resto del mundo",
    descHotelbeds: "Camas para agencias y turoperadores de todo el mundo",
    savePercentError: "No se pudo guardar el porcentaje. Inténtalo de nuevo.",
    channelGeneric: "Canal",
    statusInactive: "Inactivo",
    statusConnected: "Conectado",
    statusSyncing: "Sincronizando",
    webReservationsName: "Reservas directas vía web",
  },

  connectionChannel: {
    errorTitle: "Error",
    successTitle: "Éxito",
    connectionDisabled: "La conexión está desactivada",
    syncError: "Error al sincronizar",
    loadPropertiesError: "Error al cargar propiedades",
    connectionUpdated: "Conexión actualizada {channelName}",
    updateConnError: "Error al actualizar la conexión: {detail}",
    unknownError: "Error desconocido",
    connectionWith: "Conexión con {channelName} {status}",
    stateUpdatedTitle: "Estado actualizado",
    confirmDeleteMessage:
      "¿Estás seguro de que deseas eliminar esta conexión? Esto también eliminará las propiedades y reservas asociadas.",
    confirmDeleteHeader: "Confirmar eliminación",
    deleteConnection: "Eliminar conexión",
    no: "No",
    connectionDeleted: "Conexión eliminada exitosamente",
    deleteConnError: "Error al eliminar la conexión: {detail}",
    webhookCopied: "Webhook copiado al portapapeles",
    webhookCopyError: "Error al copiar el webhook",
    title: "Canal de conexión (PMS)",
    description:
      "En esta sección podrá conectar con sistemas de gestión de propiedades (PMS) para realizar consultas, gestión y actualización de información de forma eficiente y sin errores.",
    connectedAccount: "Cuenta conectada",
    switchTooltip:
      "Detener o activar el servicio que recibe las reservas automáticamente en el sistema.",
    syncing: "Sincronizando...",
    sync: "Sincronizar",
    deleting: "Eliminando...",
    webhookLabel: "WEBHOOK:",
    webhookInfoTooltip:
      "Agrega este Webhook a tu cuenta de Smoobu para recibir automáticamente las reservas creadas en tu PMS",
    copyToClipboard: "Copiar al portapapeles",
    syncedProperties: "Propiedades sincronizadas",
    noAddress: "Sin dirección",
    noSyncedProperties: "No hay propiedades sincronizadas",
  },

  wabaIntegration: {
    activationInProgress: "Activación en proceso",
    pendingBody:
      "Estamos activando tu WhatsApp de empresa. Mientras Meta aprueba tus plantillas (suele tardar hasta 24&nbsp;h) y verifica tu número, tus mensajes se envían con el <strong>WhatsApp de WACheckin</strong> para que no dejes de comunicarte con tus huéspedes. Cambiará a tu propio número <strong>automáticamente</strong> en cuanto esté listo — no tienes que hacer nada.",
    phoneStatusHeading: "Estado del número de WhatsApp",
    numberLabel: "Número:",
    virtualNumberNote:
      "Este es un <strong>número virtual proporcionado por Meta</strong>. No recibe llamadas ni SMS normales, solo mensajes de WhatsApp a través de la API.",
    statusLabel: "Estado:",
    templatesStatusHeading: "Estado de las plantillas",
    canSend:
      "Tu número está <strong>conectado y verificado</strong> y tienes al menos una plantilla aprobada. Ya puedes enviar mensajes.",
    cannotSendYet:
      "Aún <strong>no puedes enviar mensajes</strong>. Espera a que Meta apruebe el número de teléfono y las plantillas.",
    virtualPendingNote:
      "Ten en cuenta que, si tu negocio en Meta no está verificado, los números virtuales pueden quedarse en estado <strong>pendiente</strong> y no permitir el envío.",
    statusConnectedVerified: "Conectado y verificado",
    statusConnectedPending: "Conectado, pendiente de verificación",
    statusPendingApproval: "Pendiente de aprobación",
    statusDisconnected: "Desconectado",
    statusUnknown: "Desconocido",
  },
};
